import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AppointmentCard from "src/Components/Cards/AppointmentCard";
import ViewPrescription from "src/Components/Cards/ViewPrescription";
import httpRequest from "src/helpers/httpRequest";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import qs from "qs";
import { IPaginated } from "src/types/paginated";
import { IqueryParams } from "src/types/GlobalInterfaces";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";
import moment from "moment";
import { capitalize } from "@mui/material";

interface IPrescribedResponse {
  [key: string]: any;
}
interface IPrescribedItem {
  IPrescribedItem?: string;
  [key: string]: any;
}
const PrescriptionsSection = ({
  currentDoctor,
  onBack,
  setActivePrescription,
  activePrescription,
  setCurrentDoctor,
}: {
  currentDoctor: any;
  onBack: () => void;
  setActivePrescription: (prescription: any) => void;
  activePrescription: any;
  setCurrentDoctor: (doctor: any) => void;
}) => {
  const { allIndicators } = useSelector((store: RootState) => store?.redDots);
  const { userDetails } = useSelector((store: RootState) => store?.appReducer);

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [prescribedData, setPrescribedData] = useState<IPrescribedItem>([]);

  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    search: "",
    startDate: "",
    endDate: "",
    doctorId: currentDoctor?.id || "",
    customerId: userDetails?._id || "",
  });

  const FetchPrescibedData = async (q: IqueryParams) => {
    setIsLoader(true);

    const { res, err } = await httpRequest<IPrescribedResponse>({
      path: `/appoiment/customer-prescribe-all?${qs.stringify(q)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      setPrescribedData(
        documents.map((item: any) => ({
          id: item._id,
          name:
            capitalize(item?.firstName || "") + " " + capitalize(item?.lastName || ""),
          image: item?.doctorImg,
          specialty: item.specializations?.map((item: any) => item.name),
          qualification: item.education
            ?.map((item: any) => item.course)
            .join(", "),
          date: moment(item.prescriptionDate).format("DD-MM-YYYY"),
          fee: item?.fees,
          patientName:
            (capitalize(item?.patientFirstName || "") || "") +
            " " +
            (capitalize(item?.patientLastName || "") || ""),
          time: `${moment(item?.appointmentStartTime, "HH:mm").format(
            "hh:mm A"
          )} - ${moment(item?.appointmentEndTime, "HH:mm").format("hh:mm A")}`,
          customerNotified: item?.customerNotified,
        }))
      );
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleChangeQuery = (
    data: Partial<IqueryParams>,
    resetPage: boolean = true
  ) => {
    let newQuery = {
      ...queryParams,
      ...data,
    };
    if (resetPage) {
      newQuery.page = 1;
      setPrescribedData([]);
    }
    setQueryParams(newQuery);
    FetchPrescibedData(newQuery);
  };

  useEffect(() => {
    handleChangeQuery({ page: 1 });
  }, []);

  return (
    <div className="w-full h-full flex flex-col">
      {activePrescription ? (
        <ViewPrescription
          prescription={activePrescription}
          onClose={() => {
            setActivePrescription(null);
            onBack();
          }}
          setCurrentDoctor={setCurrentDoctor}
        />
      ) : (
        <InfinteScrollWrapper
          isLoading={isLoader}
          length={prescribedData.length}
          currentPage={queryParams.page}
          totalPages={paginated.totalPages}
          onLoadMore={(page) => handleChangeQuery({ page }, false)}
          isLoadButton={true}
          noDataOptions={{
            text2: "No Prescriptions",
          }}
          className="!pb-0"
        >
          {prescribedData.map((prescription: any, index: number) => (
            <AppointmentCard
              key={`prescription-${index}`}
              doctor={prescription}
              type="prescription"
              onViewDetails={() => {
                setActivePrescription?.(prescription);
              }}
              timeSplit={false}
              unread={prescription.customerNotified === false ? 1 : 0}
            />
          ))}
        </InfinteScrollWrapper>
      )}
    </div>
  );
};

export default PrescriptionsSection;
